<template>

  <article

    class="ws-fin-recebivel-row"

    :class="`ws-fin-recebivel-row--${status}`"

    role="button"

    tabindex="0"

    @click="$emit('open-cliente', item.clienteId)"

    @keydown.enter="$emit('open-cliente', item.clienteId)"

  >

    <div class="ws-fin-recebivel-row__bar" />

    <div class="ws-fin-recebivel-row__main">

      <div class="ws-fin-recebivel-row__head">

        <span class="ws-fin-recebivel-row__cliente">{{ item.clienteNome }}</span>

        <span class="ws-fin-recebivel-row__badge" :class="`ws-fin-recebivel-row__badge--${status}`">{{ statusLabel }}</span>

        <span v-if="recBadge" class="ws-fin-recebivel-row__rec">{{ recBadge }}</span>

      </div>

      <p v-if="item.descricao" class="ws-fin-recebivel-row__desc">{{ item.descricao }}</p>

      <p class="ws-fin-recebivel-row__meta">

        <span class="ws-fin-recebivel-row__date">

          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>

          {{ t('workspaceFinanceiroServicos.row.vencimento', { date: formatDate(item.dataVencimento) }) }}

        </span>

        <span v-if="item.pago && item.dataPagamento" class="ws-fin-recebivel-row__paid">

          {{ t('workspaceFinanceiroServicos.row.pagoEm', { date: formatDate(item.dataPagamento) }) }}

        </span>

      </p>

    </div>

    <div class="ws-fin-recebivel-row__valor" aria-hidden="true">

      <MoneyAmount :value="item.valor" size="md" />

    </div>

    <div class="ws-fin-recebivel-row__actions" @click.stop>

      <button

        type="button"

        class="ws-fin-recebivel-row__btn"

        :class="item.pago ? 'ws-fin-recebivel-row__btn--undo' : 'ws-fin-recebivel-row__btn--pay'"

        :disabled="toggling"

        :title="item.pago ? t('workspaceFinanceiroServicos.actions.desfazer') : t('workspaceFinanceiroServicos.actions.marcarPago')"

        @click="$emit('toggle-pago', item)"

      >

        <template v-if="!item.pago">

          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>

          <span class="ws-fin-recebivel-row__btn-label">{{ t('workspaceFinanceiroServicos.actions.marcarPago') }}</span>

        </template>

        <svg v-else fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 10h10a8 8 0 018 8v2M3 10l4-4m-4 4l4 4"/></svg>

      </button>

      <button
        v-if="showWhatsApp"
        type="button"
        class="ws-fin-recebivel-row__btn ws-fin-recebivel-row__btn--whatsapp"
        :disabled="!hasWhatsappPhone"
        :title="whatsappTitle"
        @click="$emit('open-whatsapp', item)"
      >
        <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
      </button>

      <button
        type="button"
        class="ws-fin-recebivel-row__btn ws-fin-recebivel-row__btn--financeiro"
        :title="t('workspaceFinanceiroServicos.actions.financeiroCliente')"
        @click="$emit('open-financeiro', item)"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
      </button>

      <button
        type="button"
        class="ws-fin-recebivel-row__btn ws-fin-recebivel-row__btn--anexos"
        :title="t('workspaceFinanceiroServicos.actions.anexosCliente')"
        @click="$emit('open-anexos', item)"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"/></svg>
      </button>

      <button type="button" class="ws-fin-recebivel-row__btn ws-fin-recebivel-row__btn--open" :title="t('workspaceFinanceiroServicos.actions.abrirCliente')" @click="$emit('open-cliente', item.clienteId)">

        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>

      </button>

    </div>

  </article>

</template>



<script setup>

import { computed } from 'vue'

import { useI18n } from 'vue-i18n'

import MoneyAmount from '@/components/MoneyAmount.vue'

import { recebivelStatus } from '@/utils/financeiroServicosMetrics'

import { recorrenciaBadge } from '@/utils/clienteRecebivelRecorrencia'



const props = defineProps({

  item: { type: Object, required: true },

  toggling: { type: Boolean, default: false },

  showWhatsApp: { type: Boolean, default: false }

})



defineEmits(['open-cliente', 'toggle-pago', 'open-whatsapp', 'open-financeiro', 'open-anexos'])



const { t } = useI18n()



const status = computed(() => recebivelStatus(props.item))



const statusLabel = computed(() => {

  const map = {

    atrasado: t('workspaceFinanceiroServicos.status.atrasado'),

    hoje: t('workspaceFinanceiroServicos.status.hoje'),

    prox7: t('workspaceFinanceiroServicos.status.prox7'),

    pendente: t('workspaceFinanceiroServicos.status.pendente'),

    pago: t('workspaceFinanceiroServicos.status.pago')

  }

  return map[status.value] || map.pendente

})



const recBadge = computed(() => {

  const b = recorrenciaBadge(props.item)

  if (!b) return null

  if (b === 'mensal') return t('workspaceFinanceiroServicos.recorrencia.mensal')

  return b

})



const hasWhatsappPhone = computed(() => !!String(props.item.clienteWhatsapp || '').trim())



const whatsappTitle = computed(() => {

  if (!hasWhatsappPhone.value) return t('workspaceClienteModal.whatsapp.phoneMissing')

  return t('workspaceFinanceiroServicos.actions.whatsapp')

})



function formatDate (iso) {

  if (!iso) return '—'

  const parts = String(iso).slice(0, 10).split('-')

  if (parts.length !== 3) return iso

  return `${parts[2]}/${parts[1]}/${parts[0]}`

}

</script>


